import { UsdcIcon } from '@/components/common/icons/usdc';
import { cn } from '@/lib/utils';

type Props = {
  title: string;
  content: string | JSX.Element;
  usdc?: boolean;
  className?: string;
  usdcClassName?: string;
};

const EventInfoRow = ({
  title,
  content,
  usdc,
  className,
  usdcClassName,
}: Props) => {
  return (
    <div className={cn('flex flex-row text-[14px] text-[#767676]', className)}>
      <div className="grow">{title}</div>
      <div className="flex items-center gap-1">
        {typeof content === 'string' ? <p>{content}</p> : content}
        {usdc && <UsdcIcon className={cn('size-[24px]', usdcClassName)} />}
      </div>
    </div>
  );
};

export default EventInfoRow;
